import React from 'react';
import { useUnitContext } from '../context/UnitContext';
export default function UnitSelector() {
  const context = useUnitContext();
  if (!context?.enabled || !context.selected) return null;
  return <div className="d-flex align-items-center gap-2 px-3 py-2 border-bottom bg-white flex-wrap">
    <label htmlFor="active-clinic-unit" className="fw-semibold text-nowrap">Unidade de trabalho</label>
    <select id="active-clinic-unit" className="form-select form-select-sm" style={{ width: 'auto', maxWidth: '100%' }} value={context.selected.id} onChange={e => context.select(e.target.value)} disabled={context.units.length === 1}>
      {context.units.map(u => <option key={u.id} value={u.id}>{u.nome}{u.is_primary ? ' (Matriz)' : ''}</option>)}
    </select>
    {!context.selected.is_primary && <small className="text-muted">{context.clinicalReady ? 'Atendimento e registros vinculados a esta filial.' : 'Recepção: agenda e carteira desta filial. Atendimento clínico ainda indisponível.'}</small>}
  </div>;
}
